let API_URL
let PUBLIC_URL = ''

if (process.env.NODE_ENV === 'production') {
  API_URL = '/api_v2'
  PUBLIC_URL = process.env.PUBLIC_URL || '' // For service worker registration
} else {
  API_URL = 'http://127.0.0.1:8000/api_v2'
}

export { API_URL, PUBLIC_URL }
